var exports = {
  "ui": "x1cb7f6e3--417680--info-row",
  "DD": "x1cb7f6e3--417680--title",
  "h_": "x1cb7f6e3--417680--description",
  "Oh": "x1cb7f6e3--417680--grey",
  "YO": "x1cb7f6e3--417680--tooltip-icon",
  "GT": "x1cb7f6e3--417680--crossed",
};

module.exports = exports;
